export const DESKTOP_MEDIA_QUERY = '(min-width: 992px)';

export const SCROLL_HEIGHT_PER_SLIDE = 1;

export const SLIDE_TRANSITION_DURATION = 1.1;

export const SLIDE_WHEEL_COOLDOWN_MS = 250;
